import { api } from './api';

let sessionId = null;

function getSessionId() {
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }
  return sessionId;
}

export async function trackEvent(eventName, eventData = {}) {
  try {
    await api.analytics.trackEvent(eventName, window.location.pathname, {
      ...eventData,
      session_id: getSessionId(),
    });
  } catch (error) {
    // Silently fail
  }
}

export async function trackPageView(pagePath, pageTitle) {
  await trackEvent('page_view', {
    page_title: pageTitle,
    referrer: document.referrer
  });
}